import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "メディア向けBtoBツールだった野球スコア分析サービス「アシスタントロボ」を、一般ユーザーが楽しめるBtoCプロダクトへ刷新。毎試合の膨大なNPBデータをリアルタイム処理しつつ、直感的なUX/UI設計とクラウドネイティブ開発でユーザーから高評価を獲得した開発事例です。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const assistantroboPageMeta: PageMeta = {
  title: "野球データ分析ツールのBtoC展開を実現｜NPBリアルタイム可視化Webアプリ開発事例 | i3DESIGN",
  description,
  keyword: "UIUX アプリケーション開発 システム化 DX推進 フロントエンド開発",
  image: primaryImage,
  url: `${SITE_URL}/cases/assistantrobo/`,
}

export const assistantroboSchema = buildCaseStudySchema({
  slug: "assistantrobo",
  pageTitle: assistantroboPageMeta.title,
  description: assistantroboPageMeta.description,
  headline: "NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援",
  alternativeHeadline: "データスタジアム株式会社",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/assistantrobo/top1.webp"],
  clientName: "データスタジアム株式会社",
  breadcrumbLabel: "NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援",
})
